<script setup>
import { useAuthStore } from '@/stores/auth.store.js';
import { router } from '@/router';

const authStore = useAuthStore();

</script>

<template>
    <div class="container vh-100 min-vh-100">
        <div class="row h-100 align-items-center d-flex justify-content-center">
            <div class="col-sm-8 mt-5">
                <router-view />
            </div>
        </div>
    </div>
</template>